export const USER_KEY = 'chat_app_user'
// export const SERVER_URI = 'https://peaceful-lowlands-37747.herokuapp.com/'
// export const SERVER_URI = 'http://localhost:4000'
export const SERVER_URI = 'https://ibu-server.onrender.com'
